import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'cam-enerji-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#7c3aed,#a855f7)">⚡</div>
        <span>Enerji Kaydı</span>
      </div>
      <div class="se-form">
        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>Enerji (kWh) <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.kwh || null" (ngModelChange)="guncelle('kwh', $event)"
                [nzMin]="0" [nzStep]="0.1" nzPlaceHolder="kWh" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>İşlem Süresi (dk)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.islemSuresi || null" (ngModelChange)="guncelle('islemSuresi', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Dakika" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Parça Adedi</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.parcaAdedi || null" (ngModelChange)="guncelle('parcaAdedi', $event)"
                [nzMin]="1" [nzStep]="1" nzPlaceHolder="Adet" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        @if (parcaBasiKwh() !== null) {
          <div style="padding:8px 12px;background:rgba(124,58,237,.08);border-radius:8px;margin-top:4px;display:flex;align-items:center;gap:12px;flex-wrap:wrap">
            <div style="display:flex;align-items:center;gap:6px">
              <span style="font-size:11px;color:var(--py-metin-ucuncul)">Parça başı:</span>
              <span style="font-size:14px;font-weight:700;color:#7c3aed">{{ parcaBasiKwh() }} kWh</span>
            </div>
            @if (saatlikTuketim() !== null) {
              <div style="display:flex;align-items:center;gap:6px">
                <span style="font-size:11px;color:var(--py-metin-ucuncul)">Saatlik:</span>
                <span style="font-size:14px;font-weight:700;color:#a855f7">{{ saatlikTuketim() }} kWh/sa</span>
              </div>
            }
          </div>
        }

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Enerji kaydı notları..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class CamEnerjiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }

  parcaBasiKwh = computed(() => {
    const kwh = +(this.p()?.kwh || 0);
    const adet = +(this.p()?.parcaAdedi || 0);
    if (!kwh || !adet) return null;
    return (kwh / adet).toFixed(2);
  });

  saatlikTuketim = computed(() => {
    const kwh = +(this.p()?.kwh || 0);
    const sure = +(this.p()?.islemSuresi || 0);
    if (!kwh || !sure) return null;
    return ((kwh / sure) * 60).toFixed(2);
  });
}
